import React from 'react';

import { SplitContainer } from './styles';
import { StaticImage } from 'gatsby-plugin-image';

interface ISplitContentProps extends React.PropsWithChildren {
  backgroundSide?: 'left' | 'right';
}

const SplitContent = ({
  children,
  backgroundSide = 'right',
}: ISplitContentProps) => {
  return (
    <SplitContainer
      className={`split_content split_content--${backgroundSide}`}
    >
      <div className="split_content__row">
        <StaticImage
          src="../../images/brisbane-local-marketing-a.jpg"
          className="split_content__mobile_image"
          alt="Brisbane river view from Howard Smith wharves"
        />
        <div
          className={`split_content__children split_content__children--${
            backgroundSide === 'left' ? 'right' : 'left'
          }`}
        >
          {children}
        </div>
      </div>
    </SplitContainer>
  );
};

export { SplitContent };
